import studyTime from '@/api/study-time'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  paymentShifts: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return studyTime.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return studyTime.store(data)
  },

  update(context, data) {
    return studyTime.update(data)
  },
  destroy(context, id) {
    return studyTime.destroy(id)
  },
  paymentShift(context) {
    return studyTime.paymentShift()
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await studyTime.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
